/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ActivateTask
 */
export interface ActivateTask {
    /**
     *
     * @type {boolean}
     * @memberof ActivateTask
     */
    activate?: boolean;
}

/**
 * Check if a given object implements the ActivateTask interface.
 */
export function instanceOfActivateTask(value: object): value is ActivateTask {
    return true;
}

export function ActivateTaskFromJSON(json: any): ActivateTask {
    return ActivateTaskFromJSONTyped(json, false);
}

export function ActivateTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ActivateTask {
    if (json == null) {
        return json;
    }
    return {
        activate: json["activate"] == null ? undefined : json["activate"],
    };
}

export function ActivateTaskToJSON(value?: ActivateTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        activate: value["activate"],
    };
}
